import { Button, Heading, Image } from '@wix/design-system'
import {
  ChoiceQuestionContentComponent,
  GroupContentComponent,
  useContent,
  useNext,
  usePageLoading,
} from '@wix/funnel-builder-lizard'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { DesignSystemTokensLoader } from '../../reusable/DesignSystemTokensLoader'
import WixHarmonyLogo from '../../reusable/icons/WixHarmonyLogo.svg'
import WixLogo from '../../reusable/icons/WixLogo.svg'
import WixVibeLogo from '../../reusable/icons/wixVibeBeta.svg'
import s from './WixVibeSplitNew.scss'

export type Content = {
  question: ChoiceQuestionContentComponent<
    {
      title: string
      subtitle?: string
    },
    {
      label: string
      description: string
      backgroundColor: string
      img: GroupContentComponent<{
        src: string
        alt: string
      }>
      btn: string
      tag: string
      logo: string
    }
  >
}

const getLogo = (logo: string) => {
  if (logo === 'harmony') {
    return <WixHarmonyLogo width="117px" height="18px" />
  }

  if (logo === 'vibe') {
    return <WixVibeLogo width="129px" height="18px" />
  }

  return <WixLogo width="44px" height="18px" />
}

export const WixVibeSplitNew: FC = () => {
  const [isPageLoading] = usePageLoading()
  const next = useNext()
  const { content } = useContent<Content>()
  const { question } = content
  const pageLogger = usePageLogger()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const handleClick = (questionKey: string, optionKey: string) => () => {
    if (isPageLoading) {
      return
    }

    void pageLogger.answer({ answer: optionKey })
    next({
      [questionKey]: { values: [optionKey] },
    })
  }

  return (
    <DesignSystemTokensLoader type="odeditor">
      <div className={s.WixVibeSplitNew}>
        <div className={s.WixVibeSplitNew__logoBox}>
          <WixLogo className={s.WixVibeSplitNew__logo} />
        </div>
        <div className={s.WixVibeSplitNew__content}>
          <Heading className={s.WixVibeSplitNew__title}>{content.question.content.title}</Heading>

          <div className={s.WixVibeSplitNew__options}>
            {question.options.map(option => (
              <div
                key={option.optionKey}
                className={s.WixVibeSplitNew__option}
                onClick={handleClick(question.questionKey, option.optionKey)}
              >
                <Image className={s.WixVibeSplitNew__image} src={option.img.content.src} alt={option.img.content.alt} />
                <div className={s.WixVibeSplitNew__caption}>
                  <span className={s.WixVibeSplitNew__icon}>{getLogo(option.logo)}</span>
                  <span className={s.WixVibeSplitNew__optionTitle}>{option.label}</span>
                  <span className={s.WixVibeSplitNew__optionSubtitle}>{option.description}</span>
                  <Button size="large" skin="dark" className={s.WixVibeSplitNew__button}>
                    {option.btn}
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </DesignSystemTokensLoader>
  )
}
